// src/components/ui/SkeletonCard.tsx
type Props = {
  height?: number | string;
  width?: number | string;
  /** Extra Tailwind classes */
  className?: string;
};

export function SkeletonCard({ height = 80, width = '100%', className = '' }: Props) {
  return (
    <div
      className={`skeleton ${className}`}
      style={{
        height,
        width,
      }}
      aria-hidden
    />
  );
}

/** A small kit of stacked skeletons mimicking a panel's contents. */
export function SkeletonPanel() {
  return (
    <div className="glass-card p-6 space-y-4 noir-panel">
      <SkeletonCard height={14} width="40%" />
      <SkeletonCard height={14} width="65%" />
      <SkeletonCard height={14} width="55%" />
      <div className="pt-3" />
      <SkeletonCard height={56} />
      <SkeletonCard height={56} />
      <SkeletonCard height={56} />
    </div>
  );
}
